/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import type { FileUploadDto } from '../models/FileUploadDto';
import type { JobCreationResponseDto } from '../models/JobCreationResponseDto';
import type { JobStatusResponseDto } from '../models/JobStatusResponseDto';

export class QuoteExtractionService {
  /**
   * Upload a quote PDF for data extraction
   * Accepts a PDF file and queues it for background processing to extract relevant quote data.
   * @param projectId The ID of the project this quote belongs to
   * @param formData PDF file upload
   * @returns JobCreationResponseDto File accepted for processing.
   * @throws ApiError
   */
  public static quoteExtractionControllerUploadQuotePdf(
    projectId: number,
    formData: FileUploadDto,
  ): CancelablePromise<JobCreationResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/quote-extraction/upload/{projectId}',
      path: {
        projectId: projectId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Invalid project ID or file type.`,
        422: `Invalid file type (only PDF allowed) or file missing.`,
      },
    });
  }

  /**
   * Get the status of a quote extraction job
   * @param jobId The ID of the job returned during upload
   * @returns JobStatusResponseDto Job status retrieved.
   * @throws ApiError
   */
  public static quoteExtractionControllerGetJobStatus(
    jobId: string,
  ): CancelablePromise<JobStatusResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/quote-extraction/jobs/{jobId}/status',
      path: {
        jobId: jobId,
      },
      errors: {
        404: `Job not found.`,
      },
    });
  }
}
